<mapfre-modal 
  *ngIf="toDo==='confirm';else removeAccount"
  [modalOptions]="profileAccountModalOptions"
  [hideModal]="hideModalOnRoute"
  (hideModalOutput)="resetHideModal()"
  (click)="resetHideModal()">
    <ng-container *ngIf="isAcmic; else maConfirm">
      <div class="modal-body no-margin-top margin-bottom mb8">  
      <hr class="no-margin-bottom no-margin-top" />
      <div class="margin-top mt24">
        {{ 'PROFILE_CHECKING_ACCOUNT_MODAL_ONE' | translate }}
      </div>
      <div class="text-center margin-bottom mb16 margin-top mt24">
        <mapfre-button
            (click)="onClickBack('stay')"
            additionalClasses="basic primary medium-btn h40 w240 mx-auto margin-bottom mb24" 
          > {{ 'STAY_HERE' | translate }}
        </mapfre-button>
          <mapfre-button
            (click)="onClickBack('back')"
            additionalClasses="ghost secondary small-btn h32 no-padding mx-auto" 
          >{{ 'DISCARD_CHANGES' | translate }}
        </mapfre-button>
      </div>
      </div>
    </ng-container>
    <ng-template #maConfirm>
      <div class="modal-body no-margin-top margin-bottom mb8 ma-profile-confirm">    
        <div class="ma-modal-title">{{'PLEASE_CONFIRM' | translate}}</div>
        <div class="ma-confirm-msg">
          {{ 'PROFILE_CHECKING_ACCOUNT_MODAL_ONE' | translate }}
        </div>
        <hr>
        <div class="text-center margin-top mt32 profile-bnt-actions">
          <mapfre-button (click)="onClickBack('stay')"
            additionalClasses="basic primary small-btn margin-bottom modal-small-btn"> {{ 'STAY_HERE' | translate }}
          </mapfre-button>
          <mapfre-button (click)="onClickBack('back')" additionalClasses="ghost secondary small-btn modal-small-btn">{{
            'DISCARD_CHANGES' | translate }}
          </mapfre-button>
        </div>
      </div>
    </ng-template>
</mapfre-modal>


<ng-template #removeAccount>
  <mapfre-modal 
  [modalOptions]="profileAccountModalOptions"
  [hideModal]="hideModalOnRoute"
  (hideModalOutput)="resetHideModal()"
  (click)="closeModal()"
  (closeModal)="closeModal()">
  <ng-container *ngIf="isAcmic; else maRemoveAccount">
    <div class="modal-body no-margin-top margin-bottom mb8">
      <hr class="no-margin-bottom no-margin-top" />
      <div class="margin-top mt24">
        {{ 'REMOVE_CHECKING_ACCOUNT_MSG_1' | translate }}
        <strong>{{ bankAccount}}</strong>
        {{ 'REMOVE_CHECKING_ACCOUNT_MSG_2' | translate }}
      </div>
      <div class="text-center">
        <mapfre-button
          (click)="onRemoveCheckingAccount('remove')"
          additionalClasses="primary basic large-btn danger margin-vertical mv24 mx-auto" 
        > {{ 'REMOVE_CHECKING_ACCOUNT' | translate }}
        </mapfre-button>
        <mapfre-button
          (click)="onRemoveCheckingAccount('cancel')"
          additionalClasses="ghost secondary  large-btn  margin-bottom mb16 mx-auto" 
        > {{ 'KEEP_BANK_ACCOUNT' | translate }}
        </mapfre-button>
      </div>
    </div>
  </ng-container>
  <ng-template #maRemoveAccount>
    <div class="modal-body no-margin-top margin-bottom mb8 ma-remove-bank-acc">
      
      <div class="margin-top mt24 ma-remove-header">
        <div class="mb8"><img src="assets/img/images/icon-warning.svg" alt="warning icon" />
        </div>
        <div class="ma-remove-msg">
        {{ 'REMOVE_CHECKING_ACCOUNT_MSG_1' | translate }}
        {{ bankAccount}}
        {{ 'REMOVE_CHECKING_ACCOUNT_MSG_2' | translate }}
      </div>
      </div>
      <div class="profile-bnt-actions">
        <mapfre-button
          (click)="onRemoveCheckingAccount('remove')"
          additionalClasses="basic primary small-btn margin-bottom modal-small-btn" 
        > {{ 'REMOVE_CHECKING_ACCOUNT' | translate }}
        </mapfre-button>
        <mapfre-button
          (click)="onRemoveCheckingAccount('cancel')"
          additionalClasses="ghost secondary small-btn modal-small-btn" 
        > {{ 'KEEP_BANK_ACCOUNT' | translate }}
        </mapfre-button>
      </div>
    </div>
  </ng-template>

  </mapfre-modal>
</ng-template>
